import React, { useState } from "react";
import { Grid, GridColumn as Column } from "@progress/kendo-react-grid";
import { useDispatch } from "react-redux";
import { ActiveCell } from "../GridComponents";
import { EditCommandCell, SignatureCell } from "../GridComponents";
import { useSelector } from "react-redux";
import { useEffect } from "react";
import { editDocType, getDocTypes } from "actions/docTypes.action";
import EditDocType from "./EditDocTypes";

const DocTypeList = () => {
  const [openForm, setOpenForm] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const [editItem, setEditItem] = useState(null);
  const enterEdit = (item) => {
    setOpenForm(true);
    setEditItem(item);
  };

  const handleSubmit = async (event) => {
    const payload = {
      code: event.code,
      typeName: event.typeName,
      active: event.active,
    };
    try {
      setIsSubmitting(true);
      await dispatch(editDocType(event.docRegisterTypeID, payload));
      setOpenForm(false);
    } finally {
      setIsSubmitting(false);
    }
  };

  const docTypeList = useSelector((state) => state.docTypes?.docTypeList);
  useEffect(() => {
    if (docTypeList !== null && docTypeList !== undefined) {
      setData(docTypeList);
    }
  }, [docTypeList]);

  useEffect(() => {
    dispatch(getDocTypes());
  }, []);

  const handleCancelEdit = () => {
    setOpenForm(false);
  };
  const MyEditCommandCell = (props) => (
    <EditCommandCell {...props} enterEdit={enterEdit} />
  );

  return (
    <div className="settings-grid">
      <Grid data={data}>
        <Column title=" " field="code" cell={SignatureCell} width="80" />
        <Column field="code" title="Code" width="100" />
        <Column field="typeName" title="Name" width="180" />
        <Column cell={ActiveCell} title="Active" width="60" />
        <Column title=" " cell={MyEditCommandCell} width="50" />
      </Grid>
      {openForm && (
        <EditDocType
          cancelEdit={handleCancelEdit}
          onSubmit={handleSubmit}
          item={editItem}
          isSubmitting={isSubmitting}
        />
      )}
    </div>
  );
};

export default DocTypeList;
